module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Big-Little-Lies-S2.efcad64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Big-Little-Lies-S2.jpg
// module id = Sn85
// module chunks = 0